import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import Slider from 'react-slick';
import css from './SelectYourTutor.module.css';
import IconCard from '../../SavedCardDetails/IconCard/IconCard';
import Button from '../../Button/Button';
import { FormattedMessage } from '../../../util/reactIntl';
import NamedLink from '../../NamedLink/NamedLink';

const PrevArrow = ({ onClick }) => (
  <button type="button" className={classNames(css.arrow, css.left)} onClick={onClick}>
    <IconCard type="prevArrow" />
  </button>
);

const NextArrow = ({ onClick }) => (
  <button type="button" className={classNames(css.arrow, css.right)} onClick={onClick}>
    <IconCard type="nextArrow" />
  </button>
);

const SelectYourTutor = () => {
  const [slideCount, setSlideCount] = useState(1.2);
  const [screenWidth, setScreenWidth] = useState();
  const sliderRef = React.useRef();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenWidth(width);
      if (width >= 1440) {
        setSlideCount(4);
      } else if (width >= 1280) {
        setSlideCount(3.5);
      } else if (width >= 768) {
        setSlideCount(2.5);
      } else {
        setSlideCount(1.1);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: slideCount,
    slidesToScroll: 1,
    centerPadding: 20,
    prevArrow: screenWidth > 600 ? <PrevArrow /> : null,
    nextArrow: screenWidth > 600 ? <NextArrow /> : null,
    arrows: screenWidth > 600,
  };

  return (
    <div className={css.wrapper} id="selectYourTutor">
      <Slider ref={sliderRef} {...settings} className={css.slider}>
        {tutors.map(tutor => (
          <div key={tutor.id} className={css.card}>
            <img src={tutor.img} alt="tutor" className={css.cardImage} />
            <div className={css.cardBody}>
              <div className={css.nameRow}>
                <span className={css.name}>
                  <FormattedMessage id={tutor.nameId} />
                </span>
                <span className={css.flag}>{tutor.flag}</span>
              </div>

              <div className={css.statsRow}>
                <div className={css.credits}>
                  <div>
                    <span className={css.value}>{tutor.credits}</span>{' '}
                    <span className={css.label}>
                      <FormattedMessage id="SelectYourTutor.credits" />
                    </span>
                  </div>
                  <span className={css.text}>
                    <FormattedMessage id="SelectYourTutor.lessonDuration" />
                  </span>
                </div>
                <div className={css.rating}>
                  <div className={css.ratingValue}>
                    <IconCard type="solidStar" />
                    <span className={css.value}>{tutor.rating}</span>
                  </div>

                  <span className={css.text}>
                    <FormattedMessage
                      id="SelectYourTutor.reviews"
                      values={{ count: tutor.reviews }}
                    />
                  </span>
                </div>
              </div>
              <p className={css.desc}>
                <FormattedMessage id={tutor.descId} />
              </p>
              <Button className={css.profileBtn} type="button">
                <FormattedMessage id="SelectYourTutor.viewProfile" /> <IconCard type="rightarrow" />
              </Button>
            </div>
          </div>
        ))}
      </Slider>

      {screenWidth <= 600 && (
        <div className={css.mobileNav}>
          <button type="button" onClick={() => sliderRef.current?.slickPrev()}>
            <IconCard type="prevArrow" />
          </button>
          <button type="button" onClick={() => sliderRef.current?.slickNext()}>
            <IconCard type="nextArrow" />
          </button>
        </div>
      )}
      <div className={css.exploreMoreTutor}>
        <NamedLink name="SearchPage">
          <FormattedMessage id="BlogPage.exploreMore" />
        </NamedLink>
      </div>
    </div>
  );
};

export default SelectYourTutor;

const tutors = [
  {
    id: 1,
    nameId: 'SelectYourTutor.tutor1.name',
    flag: '🇧🇷',
    credits: 110,
    rating: 4.9,
    reviews: 52,
    img:
      'https://images.unsplash.com/photo-1595152772835-219674b2a8a6?auto=format&fit=crop&w=600&q=80',
    descId: 'SelectYourTutor.tutor1.desc',
  },
  {
    id: 2,
    nameId: 'SelectYourTutor.tutor2.name',
    flag: '🇫🇷',
    credits: 200,
    rating: 4.9,
    reviews: 52,
    img:
      'https://images.unsplash.com/photo-1595152772835-219674b2a8a6?auto=format&fit=crop&w=600&q=80',
    descId: 'SelectYourTutor.tutor2.desc',
  },
  {
    id: 3,
    nameId: 'SelectYourTutor.tutor3.name',
    flag: '🇺🇸',
    credits: 400,
    rating: 4.9,
    reviews: 52,
    img:
      'https://images.unsplash.com/photo-1595152772835-219674b2a8a6?auto=format&fit=crop&w=600&q=80',
    descId: 'SelectYourTutor.tutor3.desc',
  },
  {
    id: 4,
    nameId: 'SelectYourTutor.tutor4.name',
    flag: '🇧🇷',
    credits: 110,
    rating: 4.9,
    reviews: 52,
    img:
      'https://images.unsplash.com/photo-1595152772835-219674b2a8a6?auto=format&fit=crop&w=600&q=80',
    descId: 'SelectYourTutor.tutor4.desc',
  },
  {
    id: 5,
    nameId: 'SelectYourTutor.tutor2.name',
    flag: '🇫🇷',
    credits: 200,
    rating: 4.9,
    reviews: 52,
    img:
      'https://images.unsplash.com/photo-1595152772835-219674b2a8a6?auto=format&fit=crop&w=600&q=80',
    descId: 'SelectYourTutor.tutor2.desc',
  },
];
